import { DialogProps } from '@material-ui/core';

import { IBaseAction } from '@/store/types/base.state';

export type TSizeModal = 'lg' | 'md' | 'sm' | 'xl' | 'xs';

export enum EModalActionTypes {
  OPEN_MODAL = 'OPEN_MODAL',
  CLOSE_MODAL = 'CLOSE_MODAL',
}

export type TOmitOnClose<T> = Omit<T, 'onClose'>;

export const TModalesActions = {
  VALIDATE: 'CONFIRM',
  CANCEL: 'CANCEL',
} as const;

export interface IDialogProps extends Partial<DialogProps> {
  maxWidth?: TSizeModal;
  isFullscreen?: boolean;
  isScrollDisabled?: boolean;
  backgroundColor?: string;
}

export const modalsKeys = [
  'passwordModal',
  'kycDocumentReviewModal',
  'kycDocumentDetailModal',
  'kycDocumentDeleteModal',
  'onboardingConfigURLModal',
  'configPasswordModal',
  'templatesVariablesModal',
  'addWebhookModal',
  'modifyWebhookModal',
  'restrictionsPredefModal',
  'restrictionGroupUploadMetadata',
  'addRestrictionGroup',
  'editRestrictionModal',
  'bulkCardRestrictionModal',
  'bulkdCardLimnitModal',
  'detailDialogBulk',
  'paymentCardSettingsModal',
  'walletOperationDetailModal',
  'downloadOperationsModal',
  'p2pTransferModal',
  'payoutModal',
  'addWalletModal',
  'kycStatusHistoryModal',
  'createBeneficiaryModal',
  'additionalVigilanceDetailModal',
  'kycDocumentUploadModal',
  'walletStatementModal',
  'walletEditionModal',
  'walletDetailModal',
  'dashboardUserUnblockModal',
  'suspendDashboardUserModal',
  'dashboardUserRemoveModal',
  'secureSCAModal',
  'createUserDiscardModal',
  'selectCompanyModal',
  'supportUserReviewModal',
  'supportUserConfirmModal',
  'sctrSimulationModal',
  'operationSimulationModal',
  'transactionSimulationModal',
  'cardUnitCreationModal',
  'mainInformationEditionModal',
  'auth2FaCreationModal',
  'viewScteBeneficiaryModal',
  'editScteBeneficiaryModal',
  'viewB2bB2cBeneficiaryModal',
  'editB2bBeneficiaryModal',
  'editB2cBeneficiaryModal',
  'accessExpirationModal',
  'changeOwnPasswordModal',
  'changeDashboardUserPasswordModal',
  'createDashboardUserModal',
  'samlKeyModal',
  'confirmationReset2faModal',
  'restoreDashboardUserAccessModal',
] as const;

export type TModalKey = (typeof modalsKeys)[number];

/* eslint-disable */
export interface IBaseModalProps extends Omit<IDialogProps, 'onSubmit' | 'onClose'> {
  onClose?: (arg?: any) => void;
  bgColor?: string;
  isFullscreen?: boolean;
  id?: string;
  onCancel?: (arg?: any) => void;
  header?: string;
  description?: string;
  ok?: boolean;
  cancel?: never;
}
/* eslint-enable */

export interface IModalProps<T extends IBaseModalProps = IBaseModalProps> {
  keyModal: TModalKey;
  props?: T;
  dialogProps?: IDialogProps;
}

export interface IOpenModalAction<T extends IBaseModalProps = IBaseModalProps> extends IBaseAction {
  type: typeof EModalActionTypes.OPEN_MODAL;
  keyModal: TModalKey;
  props?: TOmitOnClose<T>;
  dialogProps?: IDialogProps;
}
export interface ICloseModalAction extends IBaseAction {
  type: typeof EModalActionTypes.CLOSE_MODAL;
  action?: keyof typeof TModalesActions;
}

export type TCoreAction = IOpenModalAction | ICloseModalAction;

export interface ICoreState<T extends IBaseModalProps = IBaseModalProps> {
  isOpen: boolean;
  currentModal?: IModalProps<T>;
  action?: keyof typeof TModalesActions;
}
